import React from "react";
import { useParams } from "react-router-dom";
import CreateExamPage from "./CreateExamPage";

const EditExamPage: React.FC = () => {
  const { examId } = useParams<{ examId: string }>();
  return <CreateExamPage examId={examId} />;
};

export default EditExamPage;
